// extracted by mini-css-extract-plugin
export default {"Pulse":"CCButton_Pulse__hP7bN"};